__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/967e21c/_next/";